import React, {memo} from "react";
import TransactionLink from "../../../../TransactionLink";

function Number({ record }) {
    return (
        <TransactionLink
            transaction={record}
            label={record.number || '-'}
        />
    );
}

export default memo(Number);
